import { environment } from './../../../../environment/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '../../models/response-api';
import { CrudService } from '../crud-service/crud.service';
import { BehaviorSubject, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CompanyService extends CrudService<ApiResponse<any>, number> {
  profileUpdated = new BehaviorSubject<any | null>(null);
  private _cachedProfile: any;
  private _cachedId: any;
  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}/api`);
  }
  setAccount(account: any): void {
    this.profileUpdated.next(account);
  }
  
  getAccount(): Observable<any | null> {
    return this.profileUpdated.asObservable();
  }
  
  /* get esn list */
  listCompany(data?: {
    per_page?: number;
    page?: number;
    type?: number;
  }) {
    let page =1 ;
    if(data?.page) {
      page = data?.page +1
    }
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/Company/getListWithDetailsByType?per_page=${data?.per_page}&page=${page}`
    );
  }
  getCandidatReviewById(idUser:number,company_id:any){
    return this._http.get<ApiResponse<any>>(this._base+`/ResponseSpecificReview/getAvisCompanyWithResponses?user_id=${idUser}&company_id=${company_id}`);
  }
  getconsulatntList(data: {
    clientFinal_id: number;
    per_page?: number;
    page?: number;
    sort?: number;
    sortAttribute?: string;
  }) {
    let sort = '';
    if (data?.sort)
      sort = `&sort=${data.sort}&sortAttribute=${data.sortAttribute}`;
    return this._http.get<ApiResponse<any>>(
      `${this._base}/ConsultantClientFinal/getAllConsultantExterne?clientFinal_id=${data.clientFinal_id}&per_page=${data?.per_page}&page=${data?.page}${sort}`
    );
  }
  getconsulatntListattente(data: {
    clientFinal_id: number;
    per_page?: number;
    page?: number;
    sort?: number;
    sortAttribute?: string;
  }) {
    let sort = '';
    if (data?.sort)
      sort = `&sort=${data.sort}&sortAttribute=${data.sortAttribute}`;
    return this._http.get<ApiResponse<any>>(
      `${this._base}/ConsultantClientFinal/getConsultantExterneEnAttend?clientFinal_id=${data.clientFinal_id}&per_page=${data?.per_page}&page=${data?.page}${sort}`
    );
  }
  getListRoleByCompany() {
    return this._http.get<ApiResponse<any>>(
      this._base + `/CompanyRoles/getRolesByCompany`
    );
  }

  /* get  defaultResponse review of company */
  getAllReviewCompany(idCompany: any) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/ResponseSpecifictReview/SpecificReviewsbyUser?company_id=` +
        idCompany
    );
  }

  disconnectt() {
    return this._http.post<ApiResponse<any>>(
     `https://api.wegestu.com/api/auth/logout`, {});
  }

  /* get review candidat */
  getReviewCandidat(id: any) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/ResponseSpecificReview/getUsersAvisCompany?company_id=${id}`
    );
  }
  /* get review company */
  getReviewCompany(id: any) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/ResponseSpecificReview/getCompanyWithAvis?company_id=${id}`
    );
  }
  /* get all default review  */
  getAllDefaultReview(company_id?: any) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/SpecificReview/getbyCompany/${company_id}`
    );
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  /* block company */
  blockCompany(idCompany: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/Company/blockedCompany`,
      { company_id: idCompany }
    );
  }

  /* deblock company */
  deblockCompany(idCompany: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/Company/deblockCompany`,
      { company_id: idCompany }
    );
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  /* get esn by id */

  getCompanydetail(id: string) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/Company/getCompanyByIdWithDetails?company_id=${id}`
    );
  }
  getEsndetail(user_id:any,id: string) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/EsnClient/getDetailsFournisseurESN?clientFinal_id=${user_id}&fournisseur_esn_id=${id}`
    );
  }
  /*modifier company*/
  updateCompany(data: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this._base + `/Company/updateCompany`,
      data
    ).pipe(
      tap(() => {
        this._cachedProfile = null;
        this._cachedId = null;
        this.profileUpdated.next(null);
      })
    );;
  }
  
  /////////////////////////////////searche company////////////////////////////////////////////////////////////////////////////////////////////
  /* search company */
  searchCompany(data: any) {
    data.page =  data?.page ? data.page + 1 : 1;
    return this._http.post<ApiResponse<any>>(
      this._base + `/Company/search`,
      data
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /* delete */
  deleteIntervenant(uuid: string) {
    return this._http.delete<ApiResponse<any>>(
      this._base +
        `/Employee/deleteEmployee?user_id=${uuid}`
    );
  }

  /* edit intervenant */
  updateIntervenant(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/Employee/updateEmployee`,
      data
    );
  }
  /*edit profil*/
  updateProfil( data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/User/editProfileCandidat`,
      data
    );
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /* get list intervenant by company */
  getIntervenantList(
    data?: {
      per_page?: number;
      page?: number;
      type?: number;
    }
  ) {
   let page = 1;
   if(data?.page) {
    page = data?.page+1
   }
    
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/Company/getCompanyWithEmployees?per_page=${data?.per_page}&page=${page}&type=${data?.type}`
    );
  }
  /////////////////////////////////////////////////////////////////////////////////////
  getintervenant(data: any) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/Employee/getConsultantByMailForAddEmployee?email=${data.email}`
    );
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /* search intervenant esn */
  searchInterveanant(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/Company/searchIntervenant`,
      data
    );
  }
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /* get review company  by id  */
  getReviewCompanyById(id: any) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/ResponseDefaultReview/getById/` + id
    );
  }
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /* update review company */
  updateReviewCompaby(id: number, data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/ResponseDefaultReview/update/${id}`,
      data
    );
  }
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /* liste review company */

  getAllReviewReviewCompany(
    company_id: number,
    per_page: number,
    page: number,
    sort: number
  ) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/ResponseDefaultReview/reviewsbyUser?company_id=${company_id}&per_page=${per_page}&page=${page}&sort=${sort}`
    );
  }
  /*add Bulk Candidates*/
  addBulkCandidates(data: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this._base + `/Company/addBulkConsultantClient`,
      data
    );
  }
  /*get bulk candidate */
  getbulkCandidate(data: any) {
    return this._http.get(
      this._base + `/Company/exportConsultantClient/${data}`,
      {
        responseType: 'arraybuffer',
      }
    );
  }
  /*get externe consultatnt by email */
  getExternalConsultant(data?: any) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/ConsultantClientFinal/getConsultantForClientFinal?esn_name=${data.esn_name}&clientFinal_id=${data.idClient}&email=${data.email}`
    );
  }
  /*add externe consultatnt */
  addExternalConsultant(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/ConsultantClientFinal/addConsultantExterne`,
      data
    );
  }

  /*add externe consultatnt */
  getListEsnClient(id: string | null) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/ConsultantClientFinal/getFournisseursByClientFinal?clientFinal_id=${id}`
    );
  }
  /*get consultant by esn name*/
  getConsultantByEsnName(esnName: string | null) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/ConsultantEsn/getConsultantsforConsultantExterne?esn_name=${esnName}`
    );
  }
  /*search consultant*/
  searchConsultantexternel(data: any) {
    let tabs = this.findDoubleQuotes(data.search);

    if (tabs.length <= 2) data.search = '"' + data.search + '"';
    return this._http.post<ApiResponse<any>>(
      this._base + `/ConsultantClientFinal/searchInListConsultantsExterne`,
      data
    );
  }
  searchConsultantattente(data: any) {
    let tabs = this.findDoubleQuotes(data.search);

    if (tabs.length <= 2) data.search = '"' + data.search + '"';
  
    return this._http.post<ApiResponse<any>>(
      this._base + `/ConsultantClientFinal/searchInListConsultantsExterneEnAttend`,
      data
    );
  }
  findDoubleQuotes(str: string): number[] {
    const indices: number[] = [];
    for (let i = 0; i < str.length; i++) {
      if (str[i] === '"') {
        indices.push(i);
      }
    }
    return indices;
  }
  /*update consultant external*/
  updateconsultant(updatedconsultantData: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this._base + `/ConsultantClientFinal/updateConsultantExterne`,
      updatedconsultantData
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  /* add intervenant */
  createIntervenant(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/Employee/create`,
      data
    );
  }

  /* create chapitreevaluation */
  createchapitreevaluation(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/EvaluationChapter/add`,
      data
    );
  }

  getchapitreList(
    esn_id: string | null,
    data?: {
      per_page?: number;
      page?: number;
      sort?: number;
      sortAttribute: number;
    }
  ) {
    let sort = '';
    if (data?.sort)
      sort = `&sort=${data.sort}&sortAttribute=${data.sortAttribute}`;
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/EvaluationChapter/getEvaluationChapterByEsn?esn_id=${esn_id}&per_page=${data?.per_page}&page=${data?.page}${sort}`
    );
  }

  deletechapitre(id: any): Observable<any> {
    const url = `${this._base}/EvaluationChapter/delete/${id}`; // Assurez-vous d'utiliser la route correcte de mise à jour
    return this._http.delete(url);
  }

  /////////////////////////////////////////////////////////////////////////////////
  // Mettez à jour le nom du modèle (EvaluationChapter) en fonction de votre API
  /*update call offer  */

  /*update call offer  */
  updateChapitre(id: number, updatedData: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/EvaluationChapter/update/${id}`,
      updatedData
    );
  }
  /////////////////////////////////////////////////////////////////////////////////
  /* search intervenant esn */
  searchChapitre(id: any, data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/DefaultReview/searchInChaptersEvaluations?id=${id}&state=1`,
      data
    );
  }
  deleteevaluation(company_id: any, exsistName: any): Observable<any> {
    const url = `${this._base}/Evaluation/delete?company_id=${company_id}&exsistName=${exsistName}`;
    return this._http.delete(url);
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////
  updateevaluation(updatedData: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/Evaluation/update`,
      updatedData
    );
  }
  deletequestion(id: any): Observable<any> {
    const url = `${this._base}/QuestionEvaluation/delete/${id}`;
    return this._http.delete(url);
  }
  ///////////////////////////////////////////////////////////////////////////////////////////////
  updatequestion(id: number, updatedData: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/QuestionEvaluation/update/${id}`,
      updatedData
    );
  }
  /*search templateevaluation*/
  searchTemplateevaluation(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/DefaultReview/searchEvaluationByEsn`,
      data
    );
  }
  getUserByIdsidebare(id: number) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/User/userProfile?user_id=${id}`
    );
  }
  getAllPermissionsByUser() {
    return this._http.get<ApiResponse<any>>(
      this._base + `/Permission/getAllPermissionsByUser`
    );
  }
  getUserById(id:number){
    if (id !== this._cachedId) {
    return this._http.get<ApiResponse<any>>(this._base+`/User/userProfile?user_id=${id}`,{observe:'events'}).pipe(
      tap((profile) => {
        this._cachedProfile = profile;
        this._cachedId = id;
      })
    );
  } else {
    return new Observable(observer => {
      observer.next(this._cachedProfile);
      observer.complete();
    });
  }
  }
  // dissocier consultant client final
  dissocierconsultantclientfinal(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/ConsultantClientFinal/disassociateSalarieFromClientFinal`,
      data
    );
  }
  RefuserConsultant(userId: number, clientId: number) {
    const data = {
      user_id: userId,
      client_id: clientId
    };
    return this._http.post<ApiResponse<any>>(
      this._base + `/ConsultantClientFinal/deniedConsultantEnAttend?user_id=${userId}&client_id=${clientId}`,
      data
    );
  }
  AccepterConsultant(userId: number, clientId: number) {
    const data = {
      user_id: userId,
      client_id: clientId
    };
  
    return this._http.post<ApiResponse<any>>(
      this._base + `/ConsultantClientFinal/acceptConsultantEnAttend?user_id=${userId}&client_id=${clientId}`,
      data
    );
  }
  
  listPageActorIntervenant() {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/UserPageActeur/getPagesWithSubPagesForEmployee?interface=7&company_id=2&id=12`
    );
  }
  /* change Sub Page State */
  changeSubPageStateIntervenant(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/UserPageActeur/addRemoveSubPageByEmployee`,
      data
    );
  }
  /* get elment of header table call odder list */
  changeDelectedElementHeader(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base +
        `/UserPageActeur/addRemoveSubPageToUser?role_id=7&interface=7`,
      data
    );
  }
  getHeaderElementsconsultantcf(id: number) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/UserPageActeur/getPagesWithSubPagesForUser?role_id=9&interface=9&id=${id}`
    );
  }
  changeDelectedElementHeaderconsultantcf(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base +
        `/UserPageActeur/addRemoveSubPageToUser?role_id=9&interface=9`,
      data
    );
  }

  getHeaderElementssocietecf(id: number) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/UserPageActeur/getPagesWithSubPagesForUser?role_id=9&interface=9&id=${id}`
    );
  }
  changeDelectedElementHeadesocietecf(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base +
        `/UserPageActeur/addRemoveSubPageToUser?role_id=9&interface=9`,
      data
    );
  }
  listPageActorentreprisecfIntervenant() {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/UserPageActeur/getPagesWithSubPagesForEmployee?interface=9&company_id=2&id=12`
    );
  }
  changeDelectedElementcfHeader(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base +
        `/UserPageActeur/addRemoveSubPageToUser?role_id=9&interface=9`,
      data
    );
  }
  downloadcsvfileAddBulkconsultantexterne() {
    const url = `${this._base}/Company/uploadEmptyFileAddBulkConsultantClientFinal`;
    return this._http.get(url, {
      responseType: 'blob', // Changer 'arraybuffer' en 'blob'
      // observe: 'response', // Permet d'obtenir la réponse complète incluant les en-têtes
    });
  }
  fetchImageAsBlob(imageUrl: string): Observable<Blob> {
    return this._http.get(imageUrl, { responseType: 'blob' });
  }
/* delete evaluation */
deleteEvaluationDefault(id: number | undefined) {
  return this._http.delete<ApiResponse<any>>(
    this._base + `/evalEsn/template/${id}/delete`
  );
}
/* update evaluation */
updateEvaluationDefault(id: number | undefined, data: any) {
  return this._http.put<ApiResponse<any>>(
    this._base + `/evalEsn/template/${id}/update`,
    data
  );
}
  /* delete question to evaluation */
deleteQuestionEvaluation(idQuestion: number | undefined) {
  return this._http.delete<ApiResponse<any>>(
    this._base + `/evalEsn/question/${idQuestion}/delete`
  );
}
  updateQuestionEvaluation(id: number | undefined, data: any) {
    return this._http.put<ApiResponse<any>>(
      this._base + `/evalEsn/question/${id}/update`,
      data
    );
  }
 /* delete Famille */
 deletefamille(id: any): Observable<any> {
  const url = `${this._base}/evalEsn/family/${id}/delete`;
  return this._http.delete(url);
}
/* update family */
updateFamille(id: number, updatedData: any) {
  return this._http.put<ApiResponse<any>>(
    this._base + `/evalEsn/family/${id}/update`,
    updatedData
  );
}
}

